import { Button } from 'common/Button'
import { Icon } from 'common/Icon'
import { Flex } from 'primitives/Flex'
import { Heading } from 'primitives/Heading'

interface Props {
  onClose?: () => void
  onBack?: () => void
}

export const ModalTitle: React.FC<Props> = ({ children, onClose, onBack }) => (
  <Flex
    className="modaltitle"
    center
    css={{
      justifyContent: 'space-between'
    }}
  >
    <Button
      icon
      theme="secondary"
      onClick={() => onBack?.()}
      css={{ visibility: onBack ? 'visible' : 'hidden' }}
    >
      <Icon icon="Arrow" css={{ background: 'unset' }} rotate={180} />
    </Button>
    <Flex>
      <Heading as="h3">{children}</Heading>
    </Flex>
    <Button
      icon
      theme="secondary"
      onClick={onClose}
      css={{ visibility: onClose ? 'visible' : 'hidden' }}
    >
      <Icon icon="Cross" />
    </Button>
  </Flex>
)
